import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'
import { SelectorGadgetComponent } from './selector/selector-gadget.component'
import { HomeComponent } from './home/home.component'

// Route Configuration
const routes: Routes = [
	{ path: '', redirectTo: '/dfk',  pathMatch: 'full' },
	{ path: 'dfk', component: SelectorGadgetComponent}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [
		RouterModule
	],
	declarations: []
})

export class AppRoutingModule { }
